import React from 'react';
import { NavLink } from 'react-router-dom';
import { Close } from './Icons';

export default function Sidebar({ nav, basePath, open, onClose, footer }) {
  return (
    <>
      {open && <div className="docs-scrim" onClick={onClose} aria-hidden="true" />}
      <aside className={`docs-sidebar${open ? ' is-open' : ''}`} aria-label="Documentation">
        <div className="docs-sidebar-head">
          <span className="vt-eyebrow">Navigation</span>
          <button type="button" className="docs-icon-btn" onClick={onClose} aria-label="Close navigation">
            <Close size={18} />
          </button>
        </div>
        <nav className="docs-sidebar-nav">
          {!nav && Array.from({ length: 3 }).map((_, i) => (
            <div className="docs-nav-group" key={i}>
              <div className="docs-skel" style={{ width: 90, height: 10, marginBottom: 14 }} />
              {Array.from({ length: 4 }).map((__, j) => <div key={j} className="docs-skel" style={{ width: `${55 + ((i + j) % 3) * 15}%`, height: 14, margin: '12px 12px' }} />)}
            </div>
          ))}
          {nav?.map((group) => (
            <div className="docs-nav-group" key={group.section}>
              <div className="vt-eyebrow docs-nav-group-label">{group.section}</div>
              {group.pages.map((p) => (
                <NavLink
                  key={p.slug}
                  to={`${basePath}/${p.slug}`}
                  className={({ isActive }) => `docs-nav-item${isActive ? ' is-active' : ''}`}
                  onClick={onClose}
                >
                  {p.title}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        {footer}
      </aside>
    </>
  );
}
